var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "ui--aside" }, [
    _c("ul", { staticClass: "ui--aside-inner" }, [
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "user" }
        },
        [
          _c(
            "a",
            {
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.changeOffsider("user")
                }
              }
            },
            [
              _c("div", [
                _c("span", { staticClass: "ui--user-last" }, [
                  _vm._v(_vm._s(_vm.lastUserName))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.offsider === "user",
                  expression: "offsider === 'user'"
                }
              ],
              staticClass: "ui--aside-item ui--aside-user"
            },
            [
              _c("h4", [
                _c("span", { staticClass: "ui--blind" }, [
                  _vm._v("My Profile")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.changeOffsider("user")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("clear")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "ui--user-info" }, [
                _c("li", { staticClass: "mb-3" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.userInfo.userName))]),
                  _vm._v(_vm._s(_vm.$t("sdl.offsider.label.honorific"))),
                  _c(
                    "button",
                    {
                      staticClass: "btn ui--btn-logout",
                      on: { click: _vm.goLoginPage }
                    },
                    [_vm._v("Logout")]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "mb-1" }, [
                  _vm._v(_vm._s(_vm.userInfo.email))
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "mb-1" }, [
                  _vm._v(
                    _vm._s(_vm.userInfo.deptName) +
                      "/" +
                      _vm._s(_vm.userInfo.compName)
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "ui--link-user",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.changePasswordPopup }
                    },
                    [_vm._v(_vm._s(_vm.$t("sdl.identity.label.pwdChange")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "mr-1 ml-1 ui--slide" }, [
                    _vm._v("|")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "ui--link-user",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.entrustApprovalPopup }
                    },
                    [_vm._v(_vm._s(_vm.$t("sdl.offsider.label.agencyAppr")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "sitemap" }
        },
        [
          _c(
            "a",
            {
              attrs: { href: "javascript:", title: "Sitemap" },
              on: {
                click: function($event) {
                  return _vm.changeOffsider("sitemap")
                }
              }
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("apps")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui--aside-item ui--sitemap-container" },
            [
              _c("h4", [
                _vm._v("\n          Sitemap\n          "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.changeOffsider("sitemap")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("clear")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.siteMapRows, function(row, index) {
                return _c("fragment", { key: index }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.getRootMenus(index), function(menu) {
                      return _c(
                        "div",
                        { key: menu.menuId, staticClass: "col-3" },
                        [
                          menu.externalUrlUsed === true
                            ? _c(
                                "h3",
                                {
                                  staticClass: "ui--menu-title cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.openExternalUrl(
                                        menu.externalUrl
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.getLabel(menu)) +
                                      " "
                                  ),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons ui--menu-icon-1"
                                    },
                                    [_vm._v("open_in_new")]
                                  )
                                ]
                              )
                            : menu.defaultPage
                            ? _c("h3", { staticClass: "ui--menu-title" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getLabel(menu)) +
                                    " "
                                ),
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "material-icons ui--menu-icon-1"
                                  },
                                  [_vm._v("arrow_forward_ios")]
                                )
                              ])
                            : _c("h3", { staticClass: "ui--menu-title" }, [
                                _vm._v(_vm._s(_vm.getLabel(menu)))
                              ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "ui--menu-group" },
                            _vm._l(_vm.getSubmenu(menu.menuId), function(
                              submenu
                            ) {
                              return _c("li", { key: submenu.menuId }, [
                                submenu.externalUrlUsed === true
                                  ? _c(
                                      "strong",
                                      {
                                        staticClass: "cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.openExternalUrl(
                                              submenu.externalUrl
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.getLabel(submenu)) +
                                            " "
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons ui--menu-icon-2"
                                          },
                                          [_vm._v("open_in_new")]
                                        )
                                      ]
                                    )
                                  : submenu.defaultPage
                                  ? _c(
                                      "strong",
                                      {
                                        staticClass: "cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.moveMenu(
                                              submenu.defaultPage.pagePath
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.getLabel(submenu)) +
                                            " "
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons ui--menu-icon-2"
                                          },
                                          [_vm._v("arrow_forward_ios")]
                                        )
                                      ]
                                    )
                                  : _c("strong", [
                                      _vm._v(_vm._s(_vm.getLabel(submenu)))
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "ui--menu-list" },
                                  _vm._l(
                                    _vm.getSubmenu(submenu.menuId),
                                    function(item) {
                                      return _c("li", { key: item.menuId }, [
                                        item.externalUrlUsed === true
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openExternalUrl(
                                                        item.externalUrl
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.getLabel(item)
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons ui--menu-icon-3"
                                                },
                                                [_vm._v("open_in_new")]
                                              )
                                            ])
                                          : _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.moveMenu(
                                                      item.menuUrl
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getLabel(item))
                                                )
                                              ]
                                            )
                                      ])
                                    }
                                  ),
                                  0
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mb-5 border-0" })
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "quick" }
        },
        [
          _c(
            "a",
            {
              attrs: { href: "javascript:", title: "Quick Menu" },
              on: {
                click: function($event) {
                  ;(_vm.quickSubmenu = false), _vm.changeOffsider("quick")
                }
              }
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("grade")])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ui--aside-item ui--aside-quick" }, [
            _c(
              "div",
              { staticClass: "ui--quick-menu" },
              [
                _c("div", { staticClass: "ui--quick-header" }, [
                  _c("h5", [_vm._v("Quick Menu")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui--button-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { title: "Open Settings" },
                        on: {
                          click: function($event) {
                            _vm.quickSubmenu = !_vm.quickSubmenu
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("settings")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn bs-tooltip-auto",
                        attrs: { title: "Close Setting" },
                        on: {
                          click: function($event) {
                            ;(_vm.quickSubmenu = false),
                              _vm.changeOffsider("quick")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("clear")
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      staticClass: "ui--quick-list",
                      attrs: { tag: "ul", handle: ".drag-handle" },
                      on: { change: _vm.moveMenuList },
                      model: {
                        value: _vm.userMenus,
                        callback: function($$v) {
                          _vm.userMenus = $$v
                        },
                        expression: "userMenus"
                      }
                    },
                    "draggable",
                    _vm.dragOptions,
                    false
                  ),
                  _vm._l(_vm.userMenus, function(menu, index) {
                    return _c(
                      "li",
                      { key: menu.menuId },
                      [
                        menu.externalUrlUsed
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: menu.externalUrl.startsWith("http")
                                    ? menu.externalUrl
                                    : "http://" + menu.externalUrl,
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.quickSubmenu,
                                        expression: "quickSubmenu"
                                      }
                                    ],
                                    staticClass:
                                      "material-icons ui--icon-xs drag-handle",
                                    staticStyle: { cursor: "move" },
                                    attrs: { title: "Move Menu" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  drag_indicator\n                "
                                    )
                                  ]
                                ),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getLabel(menu)) +
                                    " "
                                ),
                                _c(
                                  "i",
                                  { staticClass: "material-icons menu-icon-2" },
                                  [_vm._v("open_in_new")]
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              { attrs: { to: menu.pagePath } },
                              [
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.quickSubmenu,
                                        expression: "quickSubmenu"
                                      }
                                    ],
                                    staticClass:
                                      "material-icons ui--icon-xs drag-handle",
                                    staticStyle: { cursor: "move" },
                                    attrs: { title: "Move Menu" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  drag_indicator\n                "
                                    )
                                  ]
                                ),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getLabel(menu)) +
                                    "\n              "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.quickSubmenu,
                                expression: "quickSubmenu"
                              }
                            ],
                            staticClass: "btn ui--btn-xs",
                            attrs: { title: _vm.$t("sdl.common.label.delete") },
                            on: {
                              click: function($event) {
                                return _vm.removeQuickMenu(menu.menuId, index)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("remove")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.quickSubmenu,
                    expression: "quickSubmenu"
                  }
                ],
                staticClass: "ui--aside-item ui--aside-quick ui--setting"
              },
              [
                _c("div", { staticClass: "ui--quick-menu" }, [
                  _c("div", { staticClass: "ui--quick-header" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchQuickMenu,
                          expression: "searchQuickMenu"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("sdl.offsider.label.searchMenu"),
                        autocomplete: "on"
                      },
                      domProps: { value: _vm.searchQuickMenu },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuickMenu = $event.target.value
                          },
                          function($event) {
                            _vm.searchQuickMenu = $event.target.value
                          }
                        ],
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          _vm.searchQuickMenu = ""
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui--button-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn bs-tooltip-auto",
                          attrs: { title: "Close Setting" },
                          on: {
                            click: function($event) {
                              ;(_vm.quickSubmenu = false),
                                (_vm.searchQuickMenu = "")
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("clear")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "ui--quick-list" },
                    _vm._l(_vm.filteredQuickMenus, function(menu) {
                      return _c(
                        "li",
                        {
                          key: menu.menuId,
                          class: { selected: menu.selected }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.getLabel(menu)) +
                                "\n                  "
                            ),
                            _c(
                              "i",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: menu.externalUrlUsed,
                                    expression: "menu.externalUrlUsed"
                                  }
                                ],
                                staticClass: "material-icons menu-icon-2"
                              },
                              [_vm._v("open_in_new")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn ui--btn-xs",
                              attrs: { title: _vm.$t("sdl.common.label.add") },
                              on: {
                                click: function($event) {
                                  return _vm.addQuickMenu(menu)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add")
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "trans" },
          attrs: { title: "Translation" }
        },
        [
          _c(
            "a",
            { attrs: { href: "javascript:" }, on: { click: _vm.openTrans } },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("translate")])]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "language" }
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "javascript:",
                title: _vm.$t("sdl.common.language.select")
              },
              on: {
                click: function($event) {
                  return _vm.changeOffsider("language")
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("sdl.common.language.code")))])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ui--aside-item ui--aside-language" }, [
            _c(
              "ul",
              { staticClass: "ui--language-list" },
              _vm._l(_vm.availableLocales, function(locale) {
                return _c(
                  "li",
                  {
                    key: locale,
                    class: { selected: locale === _vm.$i18n.locale },
                    attrs: { "data-locale": locale }
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.changeLocale(locale)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getLocaleLabel(locale)))]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "ui--aside-icon",
          class: { active: _vm.offsider === "timezone" }
        },
        [
          _c(
            "a",
            {
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.changeOffsider("timezone")
                }
              }
            },
            [_c("span", [_vm._v("GMT")])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ui--aside-item ui--aside-timezone" }, [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v("\n          Timezone\n          "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.changeOffsider("timezone")
                    }
                  }
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("clear")])]
              )
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.userTimezoneLabel))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("sdl.common.timezone.setting")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.timeZoneArea,
                          expression: "timeZoneArea"
                        }
                      ],
                      staticClass: "custom-select",
                      staticStyle: { "flex-basis": "110px" },
                      attrs: { required: "" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.timeZoneArea = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            _vm.timeZoneId = ""
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "Africa" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Africa")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "America" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.America")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Asia" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Asia")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Atlantic" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Atlantic")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Australia" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Australia")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Europe" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Europe")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Indian" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Indian")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Pacific" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Pacific")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Etc" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.common.timezone.Etc")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.timeZoneId,
                          expression: "timeZoneId"
                        }
                      ],
                      staticClass: "custom-select",
                      staticStyle: { "flex-basis": "250px" },
                      attrs: { required: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.timeZoneId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "", disabled: "" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.offsider.label.select")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.filteredTimeZoneList, function(time) {
                        return _c(
                          "option",
                          {
                            key: time.timeZoneId,
                            domProps: { value: time.timeZoneId }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(time.displayTimeZone) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { disabled: _vm.timeZoneId === "" },
                      on: {
                        click: function($event) {
                          return _vm.saveTimezone()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.common.label.save")) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("sdl.common.timezone.settingDesc1")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("sdl.common.timezone.settingDesc2")))
              ]),
              _vm._v(" "),
              _c("li", { staticStyle: { display: "none" } }, [
                _vm._v(_vm._s(_vm.$t("sdl.common.timezone.settingDesc3")))
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "d-flex ui--contact-info" }, [
      _c("li", { staticClass: "flex-fill" }, [
        _c(
          "a",
          { staticClass: "ui--btn-contact", attrs: { href: "javascript:" } },
          [_vm._v("Contact US")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "flex-fill" }, [
        _c(
          "a",
          { staticClass: "ui--btn-contact", attrs: { href: "javascript:" } },
          [_vm._v("IT VOC")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23397ae1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23397ae1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainOffsider.vue
// module id = null
// module chunks = 